import styled, { css } from 'styled-components';
import mainColors from '../../main-colors';
import getTypographyConfig from '../../typography-config';

const ButtonWrapper = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'negativeAction',
})`
  margin: 8px;
  background: linear-gradient(${mainColors.main_color}, transparent 60%);
  color: ${mainColors.text_color};
  padding: 4px 8px;
  border-radius: 8px;
  outline: none;
  border: 1px solid ${mainColors.main_color};
  box-sizing: border-box;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE/Edge Legacy */
  user-select: none;

  &:hover {
    background: linear-gradient(to top, ${mainColors.main_color}, transparent 60%);
  }
  &:active {
    background: ${mainColors.main_color_rgba(0.6)};
  }

  ${({ $language }) => {
    const typography = getTypographyConfig($language);

    return `
      font-size: ${16 * typography.scale}px;
      font-family: ${typography.fontFamily};
      font-weight: ${typography.fontWeight};
      line-height: ${typography.lineHeight};
    `;
  }}

  ${({ $block }) =>
    $block &&
    css`
      display: block;
      width: 100%;
    `}

  ${({ $negativeAction }) =>
    $negativeAction &&
    css`
      background: linear-gradient(${mainColors.error_color}, transparent 90%);

      &:hover {
        background: linear-gradient(to top, ${mainColors.error_color}, transparent 90%);
      }
    `}


  ${({ disabled }) =>
    disabled &&
    css`
      background: ${mainColors.main_color_rgba(0.3)};
      cursor: unset;
      color: ${mainColors.text_color_disabled};

      &:hover {
        background: ${mainColors.main_color_rgba(0.3)};
      }
    `}


    ${({ $negativeAction, disabled }) =>
    $negativeAction &&
    disabled &&
    css`
      background: ${mainColors.addOpacityTo(mainColors.error_color, 0.4)};
      color: ${mainColors.text_color_disabled};

      &:hover {
        background: ${mainColors.addOpacityTo(mainColors.error_color, 0.4)};
      }
    `}
`;

export default ButtonWrapper;
